module.exports = __webpack_public_path__ + "img/img5.527b9548.png";